module.exports = __webpack_public_path__ + "static/media/otn-request-preview.1b3a8b79.png";